import axios from "./axios-auth";

const getSidebarModules = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getusersidebarmodules",
      params: params,
      method: "get",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.error("error from api folder while calling axios");
      });
  });

export { getSidebarModules };
